<template>
  <div class="min-h-screen flex items-center justify-center p-6 bg-zinc-950 text-zinc-100">
    <div class="w-full max-w-md bg-zinc-900 p-8 rounded-2xl shadow-xl border border-zinc-800">
      <div class="text-center mb-8">
        <h1 class="text-3xl font-bold text-sky-400">Codifyo Explorer</h1>
        <p class="text-zinc-400 mt-2">Connectez-vous pour planifier et cartographier vos voyages</p>
      </div>

      <form @submit.prevent="handleLogin" class="space-y-5">
        <div class="space-y-2 text-left">
          <label class="text-sm font-medium text-zinc-400">Email</label>
          <input type="email" v-model="email" required placeholder="votre@email.com" 
                 class="w-full bg-zinc-950 border border-zinc-800 rounded-xl p-3 text-sm text-zinc-100 placeholder-zinc-600 focus:border-sky-500 focus:ring-1 focus:ring-sky-500 outline-none transition-all" />
        </div>
        
        <div class="space-y-2 text-left">
          <label class="text-sm font-medium text-zinc-400">Mot de passe</label>
          <input type="password" v-model="password" required placeholder="••••••••••••" 
                 class="w-full bg-zinc-950 border border-zinc-800 rounded-xl p-3 text-sm text-zinc-100 placeholder-zinc-600 focus:border-sky-500 focus:ring-1 focus:ring-sky-500 outline-none transition-all" />
        </div>
        
        <div v-if="error" class="p-3 bg-red-900/30 border border-red-900 text-red-400 rounded-xl text-sm text-center">
          {{ error }}
        </div>
        
        <button type="submit" class="w-full h-12 bg-sky-500 hover:bg-sky-400 text-zinc-950 rounded-xl font-bold transition-colors" :disabled="loading">
          {{ loading ? 'Connexion...' : 'Se Connecter' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const email = ref('')
const password = ref('')
const error = ref('')
const loading = ref(false)
const router = useRouter()

const handleLogin = async () => {
    error.value = ''
    loading.value = true
    
    try {
        const response = await fetch('/api/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                email: email.value, 
                password: password.value,
                app: 'explorer'
            })
        })
        
        const data = await response.json()
        
        if (!response.ok) {
            error.value = data.error || 'Échec de la connexion'
            return
        }

        localStorage.setItem('apiToken', data.token)
        if (data.roles) {
            localStorage.setItem('userRoles', JSON.stringify(data.roles))
        }
        
        router.push({ name: 'explorer_dashboard' })
    } catch (err) {
        error.value = 'Une erreur réseau est survenue'
    } finally {
        loading.value = false
    }
}
</script>
